import axios from "axios";
import { buildUrl } from "@/config";

export default {
  /**
   * Requests a short-lived opaque AES-256-GCM SSO token from the backend.
   * No personal data is sent; the backend uses the current JWT + company context.
   * The token must be treated as an opaque string by the frontend.
   *
   * @returns {Promise<import("axios").AxiosResponse<{ token: string, redirectUrl: string, expiresIn: number }>>}
   */
  createSsoToken() {
    return axios.post(buildUrl("api/v1/nethinking/sso-token"));
  },
};
